import AreaContainer from "../AreaContainer";
import ResourceImage from "./ResourceImage";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper/modules';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import styles from './ImageDisplay.module.css';
import './imageDisplay.css';
import { ResourceImageDisplay } from "lib/types";
import UnsponsoredBannerDisplay from "../Sponsored/UnsponsoredBanner";


interface Props {
  images: ResourceImageDisplay[];
  title: string;
  fallback: string;
  sponsored: boolean;
  type: string;
  portfolioName: string;
  isPaid: boolean;
  priority: boolean;
  id: number;
  availability: string[];
  category: string
  unsponsoredSign: boolean;
}

const ImageDisplay = ({ images, title, fallback, unsponsoredSign, isPaid, category, sponsored, portfolioName, type, priority, id, availability }: Props) => {
  const [isHover, setIsHover] = useState(false);

  let imagesFormatted = images;
  let sponsoredtext = portfolioName ? `This scheme has been sponsored by ${portfolioName}. To find out the benefits of Scheme Sponsorship click here.` : `This scheme has been sponsored. To find out the benefits of Scheme Sponsorship click here.`;
 
  if (!isPaid) {
    imagesFormatted = images.length > 0 ? [images[0]] : [];
  }

  if (!imagesFormatted[0]) {
    imagesFormatted = images.sort((a, b) => {
      return a.rank - b.rank;
    });
  }
  return (
    <AreaContainer area="image-display" style={null} extraClass={null}>
      <div className={styles.MainImage} id="propertyImg">
        {images.length === 0 && (
          <ResourceImage
            resource={{ media: [], title: title, id: 123 }}
            priority={priority}
            fallback={fallback}
          />
        )}
        {imagesFormatted && imagesFormatted.length === 1 && (
          <ResourceImage resource={imagesFormatted[0]} priority={priority} fallback={fallback} />
        )}
        {imagesFormatted && imagesFormatted.length > 1 && (
          <Swiper navigation={true} modules={[Navigation]} style={{
            width: "100%",
          }} slidesPerView={1}
            slidesPerGroup={1}
            loop={true}
          >
            {imagesFormatted.map((pic, index) => {
              return (
                <SwiperSlide key={pic.id}>
                  <ResourceImage resource={pic} priority={index == 0} fallback={fallback} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
        {sponsored && <a href="/landlord-pricing" className={styles.ribbon} onMouseEnter={() => {
          setIsHover(true)
        }}
          onMouseLeave={() => {
            setIsHover(false)
          }}>Featured</a>}
        {isHover && <a className={styles.messageContainer} href="/landlord-pricing">
            {sponsoredtext}
        </a>
        }
        {availability && <div className={styles.avilabilityPill}>{availability.join(' / ')}</div>}
        {/* {
          unsponsoredSign && <UnsponsoredBannerDisplay category={category} id={id} type={type} />
        } */}
      </div>
    </AreaContainer>
  );
};

export default ImageDisplay;
